import Card from '@/components/Card/Card';
import Icon from '@/components/Icons/Icon';
import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MissingItemsAlert.module.css';

interface MissingItemsAlertProps {
  className?: string;
}

export const MissingItemsAlert: FC<MissingItemsAlertProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Card className={classNames(styles.missingItemsAlertCard, className)}>
      <Icon iconName="AlertCircle" size={24} className={styles.missingItemsAlertIcon} />
      <div data-testid="missing-items-alert">{t('editBundle.bundleSettings.missingItemsReminder')}</div>
    </Card>
  );
};
